import styled from 'styled-components';
import { Song } from '../types';

const UnorderedList = styled.ul`
  padding: 0;
  padding-left: 1rem;
  margin: 0;
  font-size: 1rem;
`;

interface AnswersListProps {
  answers: Song[];
}

export function AnswersList({ answers }: AnswersListProps) {
  return (
    <UnorderedList>
      {answers.map((answer) => (
        <li key={answer}>{answer}</li>
      ))}
    </UnorderedList>
  );
}
